export default {
  brand: {
    name: 'Global Data',
    description: 'Global Data is committed to empowering enterprise digital transformation through innovative technology and creating an intelligent future together.'
  },
  quickLinks: {
    title: 'Quick Links',
    home: 'Home',
    about: 'About Us',
    coreService: 'Core Services',
    industrySolutions: 'Industry Solutions',
    caseStudies: 'Case Studies',
    resourceCenter: 'Resource Center',
    customerSupport: 'Customer Support',
    contact: 'Contact Us'
  },
  solutions: {
    title: 'Industry Solutions',
    finance: 'Finance',
    ticketAI: 'Ticket AI Assistant',
    manufacturing: 'Manufacturing',
    healthcare: 'Healthcare',
    government: 'Government & Public Services'
  },
  contactInfo: {
    title: 'Contact Information',
    address: 'Room 1003-1, Guangming Real Estate Building, No. 199 Xizang North Road, Jing\'an District, Shanghai, China'
  },
  copyright: '© 2023 Shanghai Sidong Technology Co., Ltd. All rights reserved.'
}
